<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <input-select :selectTitle="'缴费渠道'" style="margin-right: 10px;" selectWidth="120px" :selectData="payChannelList" @search="search" :selectKey="'payChannel'" />
        <input-select :selectTitle="'缴费状态'" style="margin-right: 10px;" selectWidth="120px" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />
        <!--<input-select :selectTitle="'发票状态'" :selectData="invoiceStatusList" @search="search" :selectKey="'invoiceStatus'" />-->
        <input-select :selectTitle="'账单状态'" style="margin-right: 10px;" selectWidth="120px" :selectData="invalidStatusList" @search="search" :selectKey="'invalidStatus'" />
        <span style="display: inline-block;color: #48576a;font-size: 0.0875rem;line-height: 30px;margin-right: 5px;">付款日</span>
        <el-date-picker v-model="timevalue" size="small" type="daterange" style="width: 280px;"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="btn-box">
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-search placeholder="住户名称/房间号/资金类型" @search="searchKey" />
        <button-export
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('002010001') !== -1"
          style="margin-left: 8px"
          value="导出"/>
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" :tableOperationWidth="'120px'" @changePagination="changePagination" :hasOperation="false" :operationArr="operationArr" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/InvestmentLeasing'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'deposit-management',
    data () {
      return {
        permissionCodes: "",
        breadcrumb: [{
          value: '智慧合约',
          name: 'investment-over-view'
        }, {
          value: '保证金及其他管理'
        }],
        tableHead: [
          {prop: "leaseName", label: "承租主体",},
          {prop: 'roomInfoName', label: '房间号'},
          {prop: 'payMoneyText', label: '缴费金额', width: '100'},
          {prop: 'feeType', label: '资金类型'},
          {prop: 'payDeadline', label: '付款日'},
          {prop: 'payTime', label: '缴费时间'},
          {prop: 'payChannelText', label: '缴费渠道',},
          {prop: 'payStatusText', label: '缴费状态',},
          {prop: 'invalidStatusText', label: '账单状态', width: '100'}
        ],
        exportUrl: '',
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        payChannelList: [{
          key: '',
          label: '全部'
        }, {
          key: '1',
          label: '微信'
        }, {
          key: '2',
          label: '支付宝'
        }, {
          key: '3',
          label: '银行转账'
        }, {
          key: '4',
          label: '现金'
        }, {
          key: '5',
          label: '其他'
        }],
        payStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '未缴费'
        }, {
          key: '1',
          label: '已缴费'
        }, {
          key: '2',
          label: '部分缴费'
        }, {
          key: '3',
          label: '已缴费--变更'
        }, {
          key: '4',
          label: '未缴费--变更'
        }, {
          key: '5',
          label: '已退款'
        }, {
          key: '6',
          label: '审批中'
        }],
        invoiceStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '未开票'
        }, {
          key: '1',
          label: '已开票'
        }, {
          key: '2',
          label: '开票中'
        }],
        invalidStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '正常'
        }, {
          key: '1',
          label: '已作废'
        }, {
          key: '2',
          label: '已退租'
        }],
        requestData: {
          searchKey: '',
          payChannel: '',
          payStatus: '',
          invoiceStatus: '',
          invalidStatus: '',
          feeType: '保证金',
          startTime: '',
          endTime: ''
        },
        wantModifyData: {},
        operationArr: ['modify'],
        timevalue: [],
        pickerOptions2: {
          shortcuts: [
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        }
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes;
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportForSecurityDeposit}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&invalidStatus=${this.requestData.invalidStatus}&searchKey=${this.requestData.searchKey}&feeType=${this.requestData.feeType}&payChannel=${this.requestData.payChannel}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`
      },
      getPage () {
        if (this.timevalue) {
          this.requestData.startTime = this.timevalue[0] || "";
          this.requestData.endTime = this.timevalue[1] || "";
        } else {
          this.requestData.startTime = "";
          this.requestData.endTime = "";
        }
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getPayItemDetailPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                v.payMoneyText = (v.payMoney || 0) + '元'
                if (v.payChannel === '1') {
                  v.payChannelText = '微信'
                } else if (v.payChannel === '2') {
                  v.payChannelText = '支付宝'
                } else if (v.payChannel === '3') {
                  v.payChannelText = '银行转账'
                } else if (v.payChannel === '4') {
                  v.payChannelText = '现金'
                } else if (v.payChannel === '5') {
                  v.payChannelText = '其他'
                }
                // if (v.invoiceStatus === '0') {
                //   v.invoiceStatusText = '未开票'
                // } else if (v.invoiceStatus === '1') {
                //   v.invoiceStatusText = '已开票'
                // }
                if (v.invalidStatus === '0') {
                  v.invalidStatusText = '正常'
                } else if (v.invalidStatus === '1') {
                  v.invalidStatusText = '已作废'
                } else if (v.invalidStatus === '2') {
                  v.invalidStatusText = '已退租'
                }
                this.payStatusList.map(statusItem => {
                  if (v.payStatus === statusItem.key) {
                    v.payStatusText = statusItem.label
                  }
                })
                if (v.overDayCount) {
                  v.payDeadCountText = `已逾期${v.overDayCount}天`
                  v.fontColorToPeople = '#B22222'
                } else if (v.payDeadCount) {
                  v.payDeadCountText = `${v.payDeadCount}天后到期`
                  v.fontColorToPeople = '#FF9933'
                } else {
                  v.payDeadCountText = '--'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取保证金信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        this.$router.push({
          path: `/deposit_modify/${code}`
        })
      }
    },
    watch: {
      timevalue(val) {
        this.getPage();
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
  .el-dialog__header {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/DepositManagement/DepositManagement.vue